export enum IOrderStatus {
    PENDING = 'PENDING',
    PAID = 'PAID',
    ABANDONED = 'ABANDONED'
}